import LLMModelsList from './LLMModelsList';
import ALLMModelsCreate from "./LLMModelsCreate";

export default {
    list: LLMModelsList,
    create: ALLMModelsCreate,
    edit: ALLMModelsCreate
}
